import React, { useContext } from "react";
import PropTypes from "prop-types";
import SubscriptionsContext from "../../context/subscriptions/subscriptionsContext";
const moment = require("moment");

const SubscriptionItem = ({ subscription }) => {
  const subscriptionContext = useContext(SubscriptionsContext);
  const { deleteSubscription, setCurrent, clearCurrent } = subscriptionContext;

  const onDelete = () => {
    deleteSubscription(subscription.id);
    clearCurrent();
  };

  return (
    <div className="card bg-light">
      <h3 className="text-primart text-left">{subscription.appName}</h3>
      <div className="smallText">
        {" "}
        Subscribed Since: {subscription.subscribedSince}
      </div>
      <div className="mt-3 grid-3">
        <span>
          Licensed:{" "}
          <span
            className={subscription.licensed ? "text-success" : "text-danger"}
          >
            {subscription.licensed ? "TRUE" : "FALSE"}
          </span>
        </span>
        <span>
          Paid Current:{" "}
          <span
            className={
              subscription.paidCurrent ? "text-success" : "text-danger"
            }
          >
            {subscription.paidCurrent ? "TRUE" : "FALSE"}
          </span>
        </span>
        <span></span>
      </div>

      <div className="mt-3 grid-3">
        <span>Terms: {subscription.terms ? subscription.terms : ""}</span>

        <span>
          {subscription.cutOffDate && subscription.paidCurrent === false
            ? "Cut-off Date: "
            : "Renewal Date: "}
          <span
            className={
              subscription.cutOffDate && subscription.paidCurrent === false
                ? "text-danger"
                : "text-success"
            }
          >
            {moment(subscription.cutOffDate).format("MM-DD-YYYY")}
          </span>
        </span>

        <span>
          Grace Days:{" "}
          {subscription.gracePeriodDays ? subscription.gracePeriodDays : ""}
        </span>
      </div>
      <span className="mt-3">
        Message: {subscription.message ? subscription.message : ""}
      </span>

      <p className="mt-3">
        <button
          className="btn btn-dark btn-sm"
          onClick={() => setCurrent(subscription)}
        >
          Edit
        </button>
        <button className="btn btn-danger btn-sm" onClick={onDelete}>
          Delete
        </button>
      </p>
    </div>
  );
};

SubscriptionItem.propTypes = {
  subscription: PropTypes.object.isRequired
};

export default SubscriptionItem;
